import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles33 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial33/tutorial33.zip?ref_type=heads&inline=false', download: 'tutorial33.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtyThree= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Create Vertical and Horizontal Sliders for Widget Resizing with PyQt6 and Qt Designer</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/RDf_IX-dx_I/maxresdefault.jpg"
                            alt="Tutorial 33"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                        In this PyQt6 tutorial, you'll learn how to create vertical and horizontal sliders to dynamically resize widgets using Qt Designer and Python. This step-by-step guide will show you how to design and implement intuitive, resizable user interfaces without complex coding.
                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Setting up your PyQt6 project with Qt Designer</li>
                            <li>Adding and configuring vertical and horizontal sliders</li>
                            <li>Writing Python code to link sliders for widget resizing</li>
                            <li>Creating flexible and interactive layouts</li>
                            <li>Tips for improving usability and design with resizable widgets</li>
                        </ul>

                        By the end of this tutorial, you'll be able to integrate dynamic resizing into your GUI applications, making your interfaces more user-friendly and responsive. Perfect for both beginners and experienced developers looking to enhance their PyQt6 skills.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #SliderControl #WidgetResizing #ResizableUI #PythonGUI #DesktopApp #UserInterface #GUIProgramming #ResponsiveDesign #PythonDevelopment

                    </p>

                    <button className="seemore">
                        <DownloadFiles33 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtyThree;
